import { useMemo } from 'react';

import { FieldStateKey, PermissionKey } from '@/common/constants';
import useGetPermissionToEditOverridableField from '@/modules/user/hooks/useGetPermissionToEditOverridableField';

const useGetReimbursementFieldsPermProps = () => {
  const minimumPaymentReimbursementAmountPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.MINIMUM_PAYMENT_REIMBURSEMENT_AMOUNT,
    FieldStateKey.MINIMUM_PAYMENT_REIMBURSEMENT_AMOUNT,
  );
  const waitingForFundsContinuePaymentPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.WAITING_FOR_FUNDS_CONTINUE_PAYMENT,
    FieldStateKey.WAITING_FOR_FUNDS_CONTINUE_PAYMENT,
  );
  const waitingForFundsExpirationPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.WAITING_FOR_FUNDS_EXPIRATION,
    FieldStateKey.WAITING_FOR_FUNDS_EXPIRATION,
  );
  const daysToPendReturnedChecksPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.DAYS_TO_PEND_RETURNED_CHECKS,
    FieldStateKey.DAYS_TO_PEND_RETURNED_CHECKS,
  );
  const isReimbursementAllowedPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.IS_REIMBURSEMENT_ALLOWED,
    FieldStateKey.IS_REIMBURSEMENT_ALLOWED,
  );
  const isBillPayAllowedPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.IS_BILL_PAY_ALLOWED,
    FieldStateKey.IS_BILL_PAY_ALLOWED,
  );
  const isClaimOffsetAllowedPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.IS_CLAIM_OFFSETS_ALLOWED,
    FieldStateKey.IS_CLAIM_OFFSETS_ALLOWED,
  );
  const claimOffsetLogicPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.CLAIM_OFFSET_LOGIC,
    FieldStateKey.CLAIM_OFFSET_LOGIC,
  );

  const hasFields = useMemo(() => [
    minimumPaymentReimbursementAmountPermProps,
    waitingForFundsContinuePaymentPermProps,
    waitingForFundsExpirationPermProps,
    daysToPendReturnedChecksPermProps,
    isReimbursementAllowedPermProps,
    isBillPayAllowedPermProps,
    isClaimOffsetAllowedPermProps,
    claimOffsetLogicPermProps,
  ].some((item) => !item.isAbsent), [
    minimumPaymentReimbursementAmountPermProps,
    waitingForFundsContinuePaymentPermProps,
    waitingForFundsExpirationPermProps,
    daysToPendReturnedChecksPermProps,
    isReimbursementAllowedPermProps,
    isBillPayAllowedPermProps,
    isClaimOffsetAllowedPermProps,
    claimOffsetLogicPermProps,
  ]);

  return {
    minimumPaymentReimbursementAmountPermProps,
    waitingForFundsContinuePaymentPermProps,
    waitingForFundsExpirationPermProps,
    daysToPendReturnedChecksPermProps,
    isReimbursementAllowedPermProps,
    isBillPayAllowedPermProps,
    isClaimOffsetAllowedPermProps,
    claimOffsetLogicPermProps,
    hasFields,
  };
};

export default useGetReimbursementFieldsPermProps;
